import DialogCustom from "../../../components/DesignComponents/DialogCustom";
import { DialogHandler } from "../../../shared";
import NotificationsContent from "./NotificationsContent";

const NotificationsMobile = ({ isOpen, close }: DialogHandler) => {
    return (
        <DialogCustom noPadding open={isOpen} close={close}>
            <NotificationsContent close={close} />
        </DialogCustom>
    );
};

export default NotificationsMobile;
